import React from 'react'
import CollapsedPaper from './CollapsedPaper'
import PowermeterTable from './PowermeterTable'
import { usePowermeterList } from 'src/Libs/power-meters/hooks/use-power-meters'
import { Loading } from '@e3dc-react/shell/Elements/Loading'
import { ErrorMessage } from '@e3dc-react/shell/Elements/Error'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'

interface PowermetersProps {
  storageId?: string
}

/**
 * Component that holds the powermeter tile for the hardware component section of system details.
 */
const Powermeters: React.FC<PowermetersProps> = ({ storageId }) => {
  const [powermeters, isLoading, isError] = usePowermeterList(storageId)
  const { t } = useCustomTranslation()

  return (
    <CollapsedPaper title={t('system-details.components.powermeters.title')}>
      {isError ? (
        <ErrorMessage title={t('system-details.components.powermeters.error')} />
      ) : isLoading ? (
        <Loading />
      ) : (
        <PowermeterTable powermeters={powermeters ?? []} />
      )}
    </CollapsedPaper>
  )
}

export default Powermeters
